import React, { FC, ReactElement } from 'react'

import { KlosySVGId } from '~components/homepage/svg/types/svg'

export const SlideMarker: FC = (): ReactElement => (
  <symbol id={KlosySVGId.slideMarker} viewBox="0 0 15 12">
    <path d="M8.2,2.8l4,3.2l-4,3.2V2.8z M2.8,6l4.1-3.2v6.5L2.8,6z M7.5,0.5L0.7,6l6.8,5.5L14.3,6L7.5,0.5z" />
  </symbol>
)
